var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{staticClass:"progress-bar",style:({ width: _vm.progress + '%', backgroundColor: _vm.color })})])}
var staticRenderFns = []

export { render, staticRenderFns }